// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1_rY4","approved":"Status_approved__2kQLc","rejected":"Status_rejected__Gw1u3","expired":"Status_expired__116KI","label":"Status_label__zpRZG"};